<div style="height: 310%;">
<iframe *ngIf="src" name="marinetraffic" id="marinetraffic" width="100%" height="95%" scrolling="no" frameborder="0" [src]="src">
    Browser does not support embedded objects.
    <br />Visit directly <a href="http://www.marinetraffic.com/">www.marinetraffic.com</a></iframe>
</div>